import React, { useEffect, useRef } from "react";
import "./Herosection.css";
import resume from "../assets/Neha_Vaghasiya_CV.pdf";
import { ReactTyped } from "react-typed";

const Herosection = () => {

  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      },
      { threshold: 0.3 }
    );

    const currentHero = heroRef.current;

    if (currentHero) observer.observe(currentHero);

    return () => {
      if (currentHero) observer.unobserve(currentHero);
    };
  }, []);

  return (
    <section className="hero" id="home" ref={heroRef}>
      <div className="hero-overlay">

        <h5 className="hero-anim delay-1">Hello, I'm</h5>

        <h1 className="hero-title hero-anim delay-2">
          Neha <span>Vaghasiya</span>
        </h1>
        <h2 className="hero-anim delay-3">
          <ReactTyped
            strings={[
              "IT Graduate",
              "Aspiring Full Stack Developer",
              "Passionate Coder",
            ]}
            typeSpeed={60}
            backSpeed={40}
            loop
          />
        </h2>

        <p className="hero-anim delay-4">
          I love turning ideas into interactive web experiences using
          <br />
          HTML | CSS | Bootstrap | ReactJS
        </p>

        <a href={resume} className="hero-btn hero-anim delay-5">
          Download CV
        </a>

      </div>
    </section>
  );
};

export default Herosection;
